import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './PendingMarkingModal.css';

export default function PendingMarkingModal({ isOpen, onClose, term = null }) {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isOpen) {
            fetchPendingStudents(term);
        }
    }, [isOpen, term]);

    const fetchPendingStudents = async (selectedTerm) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetch_pending_marking.php`, { params: selectedTerm ? { term: selectedTerm } : {} });
            if (response.data.success) {
                setStudents(response.data.students);
            } else {
                setError(response.data.error || 'Failed to fetch pending marking');
            }
        } catch (err) {
            setError(err.message || 'Failed to fetch pending marking');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="pending-modal-overlay" onClick={onClose}>
            <div className="pending-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="pending-modal-header">
                    <h2>Students Pending Marks{term ? ` · Term ${term}` : ''}</h2>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="pending-modal-body">
                    {loading && <div className="loading-state">Loading students...</div>}
                    
                    {error && <div className="error-state">{error}</div>}
                    
                    {!loading && !error && students.length === 0 && (
                        <div className="empty-state">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                            <p>All marks are up to date!</p>
                        </div>
                    )}
                    
                    {!loading && !error && students.length > 0 && (
                        <div className="students-list">
                            <div className="list-info">
                                <p>{students.length} student{students.length !== 1 ? 's' : ''} need{students.length === 1 ? 's' : ''} marks</p>
                            </div>
                            <table className="pending-table">
                                <thead>
                                    <tr>
                                        <th>Student Name</th>
                                        <th>Class</th>
                                        <th>Pending Subjects</th>
                                        <th>Outstanding marks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.map((student) => (
                                        <tr key={student.student_id}>
                                            <td className="student-name">
                                                {student.first_name} {student.last_name}
                                            </td>
                                            <td className="student-class">
                                                Grade {student.grade_level || 'N/A'}
                                            </td>
                                            <td className="student-subjects">
                                                {student.pending_subjects}
                                            </td>
                                            <td>
                                                <div className="pending-mark-actions">
                                                    {(student.pending_targets || []).map(target => (
                                                        <Link key={`${target.subject_id}-${target.term}`} className="pending-enter-marks" onClick={onClose}
                                                            to={`/subjects/${target.subject_id}?term=${target.term}&student=${student.student_id}&section=${target.section_id}`}
                                                            aria-label={`Enter marks for ${student.first_name} ${student.last_name}, ${target.label}, Term ${target.term}`}>
                                                            <span>{target.label} · Term {target.term}</span>
                                                            <strong>Enter marks <span aria-hidden="true">→</span></strong>
                                                            <small>{target.missing_count} outstanding</small>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <div className="pending-modal-footer">
                    <button className="btn-close" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}
